import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { AccountService } from 'src/app/services/account.service';
import { UtilsService } from 'src/app/services/utils.service';
import { SubscriptionService } from 'src/app/services/subscription.service';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  @Input() title: string;
  @Input() data: any;
  registerform: FormGroup;
  loaderVisible:boolean = false;
  userInconnu: string;
  emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  hasPhoneError: boolean;
  isFocus: unknown;
  currentPays = "Senegal";

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private toastr: ToastrService,
    private accountService: AccountService,
    private utilsService: UtilsService,
    private subscriptionService: SubscriptionService,
  ) {
    this.registerform = this.initForm();
  }

  ngOnInit() {
   
  }

  onLogin() {
    const result = { success: true };
    this.activeModal.close(result);
  }


  initForm(): FormGroup {
    return this.formBuilder.group({
      prenom: ['', [Validators.required]],
      nom: ['', [Validators.required]],
      telephone: [''],
      email: ['', [Validators.pattern(this.emailPattern)]],
    });
  }


connecter() {
  this.userInconnu = "";
  if (this.registerform.valid) {
      this.loaderVisible = true;
      let data = {
          ...this.registerform.value
      }
      this.authService.login(data)
          .subscribe((res) => {
              if (res['data']) {
                  const tokenObj = res['data'];
                  let infos = {
                      id: tokenObj.id,
                      matricule: tokenObj.matricule,
                      firstName: tokenObj.firstName,
                      lastName: tokenObj.lastName,
                      email: tokenObj.email,
                      telephone: tokenObj.telephone,
                      secteuractivite: tokenObj.secteuractivite,
                      profession: tokenObj.profession,
                      adresse: tokenObj.adresse,
                      genre: tokenObj.genre
                  }
                  let detail = {
                      id_token: tokenObj.access_token,
                      refresh_token: tokenObj.refresh_token,
                      infos: infos,
                      authorities: tokenObj.authorities
                  };
                  if (res['data']['access_token']) {
                      localStorage.setItem('microFinance', JSON.stringify(detail));
                      // localStorage.setItem('microFinanceBo', JSON.stringify(detail));
                      this.accountService.sendAccount(JSON.stringify(infos));
                      let user = detail;
                      let login = true;
                      this.loaderVisible = false;
                      this.utilsService.showToastSuccess("Effectuée avec succés", "Connexion");
                      const result = {
                         success: true,
                         user: user,
                         login: login
                         };
                      this.activeModal.close(result);
                  } else {
                    this.userInconnu = res['message'];
                      this.loaderVisible = false;
                  }
              } else {
                this.userInconnu = res['message'];
                  this.loaderVisible = false;
              }
              this.loaderVisible = false;
          }, (err) => {
              this.userInconnu = err['error']['message'] || err['error']['errors'][0]['message'];
              this.loaderVisible = false;
          });

  } else {
      this.checkValidity(this.registerform);
  }
}


inscription() {
  if (this.registerform.valid) {
      let data = {
          "prenom": this.registerform.get('prenom').value,
          "nom": this.registerform.get('nom').value,
          "telephone": this.registerform.get('telephone').value,
          "email": this.registerform.get('email').value,
          "type": "Personne Physique",
          "depuis" : "FRONT"
      }
      this.loaderVisible = true;
      this.subscriptionService.sign(data).subscribe((resp) => {
          if (resp["responseCode"] == 200) {
              this.utilsService.showToastSuccess("Les informations d'activation de votre compte vous ont été envoyées par email et/ou SMS.", "Inscription  réussie");
              this.activeModal.close();
              this.loaderVisible = false;
              this.registerform.reset();
          } else {
              this.loaderVisible = false;
              this.utilsService.showToastError(resp['message'], "Echec");
          }
          this.loaderVisible = false;
      }, error => {
          this.utilsService.showToastError(error.error.errors[0].message, "Echec");
          this.loaderVisible = false;
      });

  } else {
      this.checkValidity(this.registerform);
  }
}

checkValidity(g: FormGroup) {
  Object.keys(g.controls).forEach(key => {
      g.get(key).markAsDirty();
  });
  Object.keys(g.controls).forEach(key => {
      g.get(key).markAsTouched();
  });
  Object.keys(g.controls).forEach(key => {
      g.get(key).updateValueAndValidity();
  });
}


hasError(ev, field, form) {
  this.hasPhoneError = !ev ? true : false;
  let currentValue = this[form].get(field).value;
  if (this.currentPays == 'Côte d’Ivoire' && this.hasPhoneError) {
    if (currentValue != '') {
      if (currentValue.includes("+225") && currentValue.length != 14) {
        this.hasPhoneError = true;
        let val = currentValue.replace('+225', '');
        this[form].get(field).setValue(val);
      } else if (currentValue.length == 10 && !currentValue.includes("+225")) {
        this.hasPhoneError = false;
        let value = '+225' + currentValue;
        this[form].get(field).setValue(value);
      } else if (currentValue.includes("+225") && currentValue.length == 14) {
        let val = currentValue.replace('+225', '');
        this[form].get(field).setValue(val);
        this.hasPhoneError = false;
      }
    }
  } else if (this.currentPays == 'Côte d’Ivoire' && !this.hasPhoneError) {
    let val = currentValue.replace('+225', '');
    this[form].get(field).setValue(val);
    this.hasPhoneError = true;
  }
}
getNumber(ev, field, form) {
  if (this.currentPays != 'Côte d’Ivoire')
    this[form].get(field).setValue(ev);
}
telInputObject(ev) {
  // console.log("telNUm-EV",ev);
}
parseIntValue(value) {
  return parseInt(value);
}
onCountryChange(ev) {
  let value = ev['name'].toString();
  let val = "";
  for (let i = 0; i < value.length; i++) {
    if (value[i] == '(') {
      val = value.substring(0, i - 1);
      this.currentPays = val;

    } else {
      this.currentPays = value;
    }
  }

}


}
